module.exports = __webpack_public_path__ + "static/media/bl.38e27b68.svg";